import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import type { EntiteTransferante, LieuParticulier } from "models/Transfert";

interface PerimetreSansTerritoirePorteesAccordionSummaryProps {
  entiteTransferante: EntiteTransferante;
  lieuParticulier: LieuParticulier;
}

function PerimetreSansTerritoirePorteesAccordionSummary({
  entiteTransferante,
  lieuParticulier,
}: Readonly<PerimetreSansTerritoirePorteesAccordionSummaryProps>): ReactNode {
  return (
    <Typography sx={{ ml: 2 }}>
      <Typography component="span" color="primary" sx={{ fontWeight: 500 }}>
        {lieuParticulier.libelle}
      </Typography>
      <br />
      Adhésion directe - {entiteTransferante.libelle}
    </Typography>
  );
}

export default PerimetreSansTerritoirePorteesAccordionSummary;
